























































import { Vue, Component } from 'vue-property-decorator'
import { EMAIL_PATTERN } from "@/util";
// from validatejs

@Component
export default class SignUpForm extends Vue {
  error = ''
  state: 'idle' | 'busy' | 'done' = 'idle'

  input = {
    valid: false,
    email: '',
    emailRules: [
      (v: any) => !!v || 'Please enter your email',
      (v: any) => (v && EMAIL_PATTERN.test(v)) || 'Please enter a valid email.'
    ],
    password: '',
    passwordRules: [
      (v: any) => !!v || 'Please enter a password',
      (v: any) => (v && v.length >= 8) || 'Password must be at least 8 character'
    ],
    rePassword: '',
    rePasswordRules: [
      (v: any) => !!v || 'Please confirm your email by entering it again',
      (v: any): true | string => (v === this.input.password) || "Passwords don't match"
    ]
  }

  async signUp() {
    if (!this.input.valid) return

    this.error = ''
    this.state = 'busy'
    try {
      await this.authService.register({ email: this.input.email, password: this.input.password })
      this.addToWaitList(this.input.email)
      this.state = 'idle'
    } catch (error) {
      this.state = 'idle'
      this.error = error.message
    }
  }

  addToWaitList(email: string) {
    window.open('https://referlist.co/joinwaitList/remoteventuresapp?email=' + email)
    this.$router.replace('/waitList')
    // maybe log the user in (which will check that )
    // this.state = "done"
  }
}
